<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item to="/personalList" @click="updateListCategory('personalList')">Personal List
      </b-breadcrumb-item>
      <b-breadcrumb-item href="#personalToDoListName" active>{{toDoListDetails.toDoListName}}</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">{{toDoListDetails.toDoListName}}</h1>
    <p v-if="toDoListDetails.toDoListDescription">{{toDoListDetails.toDoListDescription}}</p>
    <p v-else>No description provided.</p>
    <hr>
    <div class="task-container">
      <div v-if="showPlaceholderImage && !hideWhenInitialLoad" class="no-task-container">
        <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
               alt="No task picture"></b-img>
        <h2>Your task list is empty</h2>
        <p>Congratulations, you have #NoStuffToDo!</p>
      </div>
      <regular-task-cell v-for="personalTask in personalTaskDocuments" :key="personalTask.taskId"
                         :task-details="personalTask"></regular-task-cell>
    </div>
    <fab
        position="bottom-right"
        bg-color="#565A7B"
        icon-size="small"
        @click.native="openCreationModal"
    ></fab>
  </div>
</template>

<script>
  import RegularTaskCell from "../table_cells/task_cells/RegularTaskCell"
  import {mapActions, mapGetters} from "vuex"
  import {db} from "../../main"
  import fab from 'vue-fab'

  export default {
    name: "PersonalTaskList",
    data() {
      return {
        showPlaceholderImage: null,
        hideWhenInitialLoad: true,
        toDoListId: null,
        toDoListDetails: {},
        personalTaskDocuments: []
      }
    },
    components: {
      regularTaskCell: RegularTaskCell,
      fab
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      openCreationModal() {
        this.$store.dispatch('setupCreationModal')
        this.showModal('creation-modal')
      },
      getSortedPersonalTaskData(sortProperties) {
        if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .orderBy('taskCreationTime', 'asc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Creation time' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .orderBy('taskCreationTime', 'desc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Task name' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Ascending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .orderBy('priority', 'asc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortProperties.sortTypeSelected === 'Priority' && sortProperties.sortDirectionSelected === 'Descending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .orderBy('priority', 'desc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      },
      getFilteredPersonalTaskData(filterProperties) {
        if (filterProperties.filterTypeSelected === 'None') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .orderBy('taskCreationTime', 'asc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('completed', '==', true)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Completed task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('completed', '==', true)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Ascending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('completed', '==', false)
              .orderBy('taskName', 'asc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (filterProperties.filterTypeSelected === 'Incomplete task' && filterProperties.filterDirectionSelected === 'Descending') {
          this.$bind(
            'personalTaskDocuments',
            db
              .collection('personal_to_do_lists/' + this.toDoListId + '/tasks')
              .where('toDoListId', '==', this.toDoListId)
              .where('completed', '==', false)
              .orderBy('taskName', 'desc')
          ).then(() => {
            if (this.personalTaskDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      },
      showModal(id) {
        this.$root.$emit('bv::show::modal', id)
      }
    },
    computed: {
      ...mapGetters([
        "sortTaskListProperties",
        "filterTaskListProperties"
      ])
    },
    watch: {
      personalTaskDocuments(newProperties, oldProperties) {
        this.showPlaceholderImage = this.personalTaskDocuments.length === 0
      },
      sortTaskListProperties(newSortProperties, oldSortProperties) {
        this.getSortedPersonalTaskData(newSortProperties)
      },
      filterTaskListProperties(newFilterProperties, oldFilterProperties) {
        this.getFilteredPersonalTaskData(newFilterProperties)
      }
    },
    mounted() {
      this.toDoListId = this.$route.params.personalListId

      db.collection('personal_to_do_lists')
        .doc(this.toDoListId)
        .onSnapshot(doc => {
          this.toDoListDetails = doc.data()
          this.$store.dispatch('setCurrentToDoListName', this.toDoListDetails.toDoListName)

          this.getSortedPersonalTaskData({
            sortTypeSelected: 'Creation time',
            sortDirectionSelected: 'Ascending'
          })
        })
    },
    destroyed() {
      this.$store.dispatch('setCurrentToDoListName', '')
    }
  }
</script>

<style scoped>
  .no-task-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-task-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .task-container {
    height: 68vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }
</style>
